import api from './api'; // Preconfigured axios instance with baseURL

export const subscriptionService = {
  async createCheckoutSession(): Promise<{ url: string }> {
    const response = await api.post('/subscription/create-checkout-session');
    return response.data;
  },

  async verifyPayment(sessionId: string): Promise<any> {
    const response = await api.post('/subscription/verify-payment', { sessionId });
    return response.data;
  },

  async checkSubscriptionStatus(): Promise<any> {
    const response = await api.get('/subscription/status');
    return response.data;
  },

  async cancelSubscription(): Promise<any> {
    const response = await api.post('/subscription/cancel');
    return response.data;
  },

  async submitTeamContact(data: {
    name: string;
    email: string;
    company: string;
    teamSize: string;
    message: string;
  }): Promise<any> {
    const response = await api.post('/subscription/team-contact', data);
    return response.data;
  }
};
